import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Flex from 'base/components/Flex';
import Loader from 'base/components/Loader';
import ScrollBar from 'base/components/ScrollBar';
import { getNews, getNewsHasError, getNewsIsLoading } from '../../store/selectors';
import { fetchNews } from '../../store/actions';
import NewsList from '../../components/NewsList';
import NewsSkeleton from '../../components/NewsSkeleton';

const WidgetWrapper = styled(Flex)`
  position: relative;
  flex-direction: column;
  height: 100%;
`;

class AdwiredNewsWidget extends React.Component {
  componentDidMount() {
    this.props.fetchNews();
  }


  render() {
    const {
      news,
      isLoading,
    } = this.props;

    return (
      <WidgetWrapper>
        <ScrollBar>
          <Loader isLoading={isLoading} fallback={<NewsSkeleton />}>
            <NewsList news={news} />
          </Loader>
        </ScrollBar>
      </WidgetWrapper>
    );
  }
}
AdwiredNewsWidget.propTypes = {
  news: PropTypes.arrayOf(PropTypes.any).isRequired,
  isLoading: PropTypes.bool.isRequired, // eslint-disable-line
  fetchNews: PropTypes.func.isRequired,
};
AdwiredNewsWidget.defaultProps = {
};

const mapStateToProps = (state) => ({
  news: getNews(state),
  isLoading: getNewsIsLoading(state),
  hasError: getNewsHasError(state),
});
const mapDispatchToProps = {
  fetchNews,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdwiredNewsWidget);
